import {RouteObject, redirect} from 'react-router';

import {EAgentPaymentsTab} from 'src/containers/Agent/definitions';

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(EAgentPaymentsTab.REPORT),
  },
  {
    path: EAgentPaymentsTab.REPORT,
    lazy: async () => ({
      Component: (await import('./ReportTab')).ReportTab,
    }),
  },
  {
    path: EAgentPaymentsTab.DOCUMENTS,
    lazy: async () => ({
      Component: (await import('./DocumentsTab')).DocumentsTab,
    }),
  },
];

export const agentPaymentsRoutes: RouteObject = {
  children,
};
